import { useReducer } from 'react';
import BN from 'bn.js';

import { TokenProjectType } from 'types';
import { parseTokenAmount } from 'utils/amounts';
import { isValidAmount, sumNumberHelper } from 'utils';

const initialState = {
  sum: '',
  selected: [],
  handleSelectOne: () => {},
  handleChangeOne: () => {}
};

type PropsTypes = {
  sum?: string;
  selected?: TokenProjectType[];
  handleSelectOne?: (row: TokenProjectType) => void;
  handleChangeOne?: (project_id: string, value: string) => void;
};

const reducer = (s: PropsTypes, v: PropsTypes) => ({ ...s, ...v });

const checkError = (value, balance) => {
  const getRawAmount = () => parseTokenAmount(value, 24);

  const isValid = () => {
    return (
      !new BN(getRawAmount()).isZero() &&
      new BN(getRawAmount()).lte(new BN(parseTokenAmount(balance, 0)))
    );
  };

  if (isValidAmount(value) && new BN(getRawAmount()).isZero()) {
    return 'Value is Zero';
  }

  if (isValidAmount(value) && !isValid()) {
    return 'Balance is Exceeded';
  }

  return '';
};

const useSelectedProjects = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { selected, sum } = state;

  const setSelected = (selected: TokenProjectType[]) => {
    const items = selected.map((item) =>
      item.value ? item : { ...item, value: '', error: '' }
    );

    dispatch({
      selected: items,
      sum: sumNumberHelper(items)
    });
  };

  const handleSelectOne = (item) => {
    const selectedIndex = selected.findIndex(
      (element) => element.project_id === item.project_id
    );
    let newSelected: TokenProjectType[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, item);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangeOne = (id, value) => {
    const activeSelected = selected.map((item) =>
      item.project_id === id
        ? {
            ...item,
            value,
            error: checkError(value, item.balance)
          }
        : item
    );

    dispatch({
      selected: activeSelected,
      sum: sumNumberHelper(activeSelected)
    });
  };

  const clearAll = () => {
    dispatch({
      selected: [],
      sum: ''
    });
  };

  return { selected, clearAll, sum, handleSelectOne, handleChangeOne };
};

export default useSelectedProjects;
